import React from 'react'
import { Container, ContentInLine, SkeletonItem } from './styles'

export const ModalHeaderSkeleton = (): JSX.Element => {
  return (
    <Container data-testid="modal-header-skeleton">
      <SkeletonItem width={'100%'} height={'24px'} />
      <ContentInLine>
        <SkeletonItem width={'116px'} height={'24px'} />
        <SkeletonItem width={'204px'} height={'24px'} />
      </ContentInLine>
      <SkeletonItem width={'100%'} height={'2px'} />
    </Container>
  )
}
